export class DiscussionVisibilityConstants {
  public static readonly INTERNAL = "Internal";

  public static readonly EXTERNAL = "External";
}
